// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6b50b01","455":"b80060a9","977":"77bb8d45"}[chunkId] + ".chunk.js";
};